import { render, staticRenderFns } from "./ParcelManual.vue?vue&type=template&id=284a0fec&scoped=true&"
import script from "./ParcelManual.vue?vue&type=script&lang=js&"
export * from "./ParcelManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284a0fec",
  null
  
)

export default component.exports